import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import ScrollToTop from '@/components/base/ScrollToTop';
import SEO from '@/components/base/SEO';
import SchemaOrg from '@/components/base/SchemaOrg';
import HeroSection from './components/HeroSection';
import FeaturesSection from './components/FeaturesSection';
import CategoryNav from './components/CategoryNav';
import LatestArticles from './components/LatestArticles';
import FAQSection from './components/FAQSection';
import { Link } from 'react-router-dom';

export default function Home() {
  return (
    <>
      <ScrollToTop />
      <SEO
        title="91n.com - 官方入口与核心功能全解析 | 注册登录·使用指南·常见问题"
        description="91n.com 是您值得信赖的网络平台，全面介绍 91n.com 的官方入口、核心功能、使用指南及常见问题解答，帮助用户快速找到 91n.com 并充分利用其全部服务，立即访问体验。"
        keywords="91n.com,91n.com官方入口,91n.com使用指南,91n.com功能介绍,91n.com注册登录,91n.com最新地址,91n.com常见问题"
        canonicalUrl="/"
      />
      <SchemaOrg type="WebSite" />
      <SchemaOrg type="Organization" />
      <SchemaOrg type="WebPage" data={{
        name: '91n.com 官方网站首页',
        description: '91n.com 官方入口与核心功能全解析，帮助用户快速找到91n.com并充分利用其全部服务。',
      }} />
      <SchemaOrg type="BreadcrumbList" />

      <Navbar />

      <main>
        <HeroSection />
        <FeaturesSection />
        <CategoryNav />
        <LatestArticles />

        <section className="py-16 md:py-20 bg-primary-500">
          <div className="max-w-[1280px] mx-auto px-4 md:px-6 text-center">
            <h2 className="text-2xl md:text-3xl font-bold text-background-50 font-heading">
              立即访问 91n.com 官方入口
            </h2>
            <p className="mt-3 text-background-50/80 text-sm md:text-base max-w-xl mx-auto">
              认准 91n.com 唯一官方域名，安全畅享全部平台服务
            </p>
            <div className="mt-6 flex flex-col sm:flex-row items-center justify-center gap-4">
              <Link
                to="/category/register-login"
                className="px-8 py-3 bg-background-50 text-primary-500 rounded-md font-medium text-sm hover:bg-background-100 transition-colors whitespace-nowrap cursor-pointer"
              >
                新用户注册指南
              </Link>
              <Link
                to="/about"
                className="px-8 py-3 bg-primary-600 text-background-50 rounded-md font-medium text-sm hover:bg-primary-700 transition-colors whitespace-nowrap cursor-pointer"
              >
                关于 91n.com
              </Link>
            </div>
          </div>
        </section>

        <FAQSection />
      </main>

      <Footer />
    </>
  );
}